export default __webpack_public_path__ + "static/media/Resume.4856b7ab.pdf";